import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("careo_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Don't tear down the session for auth endpoints whose 401 carries an actionable
      // message (wrong password, wrong Branch PIN, etc.). Let the calling component show it.
      const url = err.config?.url || "";
      const isAuthEndpoint = /\/auth\/(login|select-branch)$/.test(url);
      if (!isAuthEndpoint) {
        localStorage.removeItem("careo_token");
        localStorage.removeItem("careo_pending_branches");
        localStorage.removeItem("careo_needs_branch_pin");
        if (window.location.pathname !== "/login") {
          window.location.assign("/login");
        }
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}


/** Format any ISO/parseable timestamp as Indian Standard Time. */
export function formatIST(iso, opts = {}) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      year: "numeric", month: "short", day: "2-digit",
      hour: "2-digit", minute: "2-digit",
      ...opts,
    });
  } catch (_) { return String(iso); }
}

/** Today's date (YYYY-MM-DD) in IST — use for date inputs that must default to "today". */
export function todayIST() {
  const parts = new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Kolkata", year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(new Date());
  const y = parts.find((p) => p.type === "year").value;
  const m = parts.find((p) => p.type === "month").value;
  const d = parts.find((p) => p.type === "day").value;
  return `${y}-${m}-${d}`;
}
export const BRAND = {
  name: "CareO",
  tagline: "EMR for Eye Care",
  fullName: "CareO — EMR for Eye Care",
  logo: "https://customer-assets.emergentagent.com/job_eye-care-saas/artifacts/4n7i4eyb_53561592_transparent.png",
  icon: "https://customer-assets.emergentagent.com/job_eye-care-saas/artifacts/4n7i4eyb_53561592_transparent.png",
  footer: "CareO · EMR for Eye Care · powered by Steward Healthcare India Pvt Ltd",
};
